import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { PeopleActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createPerson = (data): any => action(types.CREATE_PERSON_REQUESTED, data);

export const updatePerson = (data): any => action(types.UPDATE_PERSON_REQUESTED, data);

export const deletePerson = (personId): any => action(types.UPDATE_PERSON_REQUESTED, personId);

export const getPerson = (personId): any => action(types.GET_PERSON_REQUESTED, personId);

export const getAllPeople = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_PEOPLE_REQUESTED, {
  pagination,
  compile,
});

export const selectPerson = (personId): any => action(types.SELECT_PERSON_REQUESTED, {
  currentPersonId: personId,
});

export function togglePersonCreateModal() {
  return action(types.TOGGLE_PERSON_CREATE_MODAL);
}

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createPersonPending: (payload): any => action(types.CREATE_PERSON_PENDING, payload),
  createPersonSuccess: (response): any => {
    const currentPerson = response.entities.people[response.result];
    // history.push(`/payment/${currentPerson.paymentCollection.id}/review`);
    return action(types.CREATE_PERSON_SUCCESS, {
      peopleById: response.entities.people,
      currentPersonId: response.result,
    });
  },
  updatePersonPending: (payload): any => action(types.UPDATE_PERSON_PENDING, payload),
  updatePersonSuccess: (response): any => action(types.UPDATE_PERSON_SUCCESS, {
    peopleById: response.entities.people,
    currentPersonId: response.result,
  }),
  updatePersonFailed: (error): any => action(types.UPDATE_PERSON_FAIL, { backendErrors: error }),
  deletePersonPending: (): any => action(types.UPDATE_PERSON_PENDING, {}),
  deletePersonSuccess: (response, userId): any => {
    localStorage.set(userId, { currentPersonId: null });
    history.push("/customers");

    return action(types.DELETE_PERSON_SUCCESS, {
      currentPersonId: response,
    });
  },
  getPersonPending: (): any => action(types.GET_PERSON_PENDING, {}),
  getPersonSuccess: (response): any => action(types.GET_PERSON_SUCCESS, {
    peopleById: response.entities.people,
    currentPersonId: response.result,
  }),
  getPersonFailed: (error): any => action(types.GET_PERSON_FAIL, { backendErrors: error }),
  deletePersonFailed: (error): any => action(types.UPDATE_PERSON_FAIL, { backendErrors: error }),
  getAllPeoplePending: (pagination): any => action(types.GET_ALL_PEOPLE_PENDING, { pagination }),
  getAllPeopleSuccess: (response, meta): any => action(types.GET_ALL_PEOPLE_SUCCESS, {
    peopleById: response.entities.people,
    peopleIds: response.result,
    meta,
  }),
  getAllPeopleFailed: (error): any => action(types.GET_ALL_PEOPLE_FAIL, { backendErrors: error }),
  createPersonFailed: (error): any => action(types.CREATE_PERSON_FAIL, { backendErrors: error }),
};

export default null;
